import { render, staticRenderFns } from "./index-new.vue?vue&type=template&id=2acdd246"
import script from "./index-new.vue?vue&type=script&lang=js"
export * from "./index-new.vue?vue&type=script&lang=js"
import style0 from "./index-new.vue?vue&type=style&index=0&id=2acdd246&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports